// @flow

export { GooglePayForm } from './google-pay-form';
